<template>
  <div class="p-fluid">
    <div class="p-col-12 p-lg-12">
      <div class="card card-w-title">
        <div class="manager-title-custom">{{ title }}</div>
        <!-- <div class="note">(*) Nội dung không được bỏ trống</div> -->
        <formEdit
          :key="componentKey"
          :mode="mode"
          :company_id="company_id"
          @company="changeCompany"
          @save="saveData"
          :model="models"/>
      </div>
    </div>
  </div>
</template>
    
<script>
// import Config from '../../../config/index'
import formEdit from './add'
import ApiRepository from "@/core/ApiRepository";
export default {
  components: {
    formEdit
  },
  data() {
    return {
      users: null,
      validationErrors: [],
      title: "Cấu Hình Đánh Giá Lại",
      mode: 'add',
      models: {},
      componentKey: 0,
      accountID: '',
      page_transaction:null,
      setting_id: null,
      company_id: null
    }
  },
  created() {
    this.$set(this,'company_id', (this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN) ? this.$store.getters?.company_id : null);
    console.log(this.company_id);
  },
  watch: {
    "company_id"() {
      if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.componentKey++;
      }
    },
    "$store.getters.company_id"() {
      if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.$set(this,'company_id', (this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN) ? this.$store.getters?.company_id : null);
        this.getData();
      }
    },
  },
  async mounted () {
    await this.getData();
    this.mode = this.$route.name === 'editsetting' ? 'edit' : this.mode;
    this.title = this.mode === 'edit' ? 'Cấu Hình Đánh Giá Lại' : this.title;
  },
  methods: {
    async changeCompany(value) {
      this.company_id = value;
      if (this.company_id){
        await this.getData();
      }
    },
    async saveData(params) {
      var that = this;
      let objects = {
        company_id: params?.company ? params.company.id : null,
        first_active: params.first_active,
        first_month: params.first_month,
        second_active: params.second_active,
        second_month: params.second_month,
        control_measures: params.control_measures,
        prioritize: params.prioritize
      }
      this.company_id = params?.company ? params.company.id : null;
      var token = that.$store.getters.token ? that.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        objects.id = this.setting_id;
        await ApiRepository.post("/_api/setting/edit", objects, {headers}).then(async function (response) {
          if (response.status === 200) {
            that.redirectEdit();
          } else {
            that.$toast.add({
                severity: 'error',
                summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: response.data.message,
                life: 3000
            });
            that.$commonFuction.is_loading(false);
          }
          if ((that.$store.getters?.type != that.$constants.TYPE_USER.SUPPER_ADMIN)) {
            that.company_id = that.$store.getters?.company_id;
          }
        }).catch((err) => {
          console.log('errorerrorerrorerror', err);
          that.$toast.add({
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: err,
              life: 3000
          });
          that.$commonFuction.is_loading(false);
        })
      }
    },
    async redirectEdit() {
      var that = this;
      that.$commonFuction.is_loading(false);
      that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Lưu dữ liệu thành công', life: 3000 })
      this.getData();
    },
    async getData() {
      var company_id = this.company_id ?? null;
      if(this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN){
        company_id = this.$store.getters.company_id ?? null;
      }
      if (company_id) {
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
          const headers = {
            "Authorization": "Bearer "+token,
          };
          var {data} = await ApiRepository.post("/_api/setting/detail", {company_id: company_id}, {headers});
          var value = data.data;
          this.setting_id = value?.id ?? null;
          this.models = value;
        }
      }
    },
  },
  apollo: {
    
  }
}
</script>

<style lang="scss">
  .manager-title-custom{
    color: #1D3118;
    font-size: 18px;
    margin-bottom: 16px;
    padding-bottom: 10px;
    border-bottom: 1px solid #EEEEEE;
    font-weight: 700;
  }
.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only { padding: 0 !important; }
  }
}
.note{ letter-spacing: 0px; color: #707070; margin-bottom: 24px; padding-top: 10px;}
.p-formgrid { margin: 0;
  .p-panel-header {color: #000000; font-size: 18px; font-weight: bold; background: #EEEEEE;}
  .p-card-field{ padding: 24px;
    .p-field{
      .p-col-fixed { width: 300px; display: inline-block !important; margin: 0;}
      .p-col-width{width:500px !important; border-radius: 5px;
        &.disabled{background: #EEEEEE; border: 0 none; padding: 8px 10px;}
        .file-select{margin: 0;
          input[type="file"]{display: none;}
          .select-button{display: inline-block; cursor: pointer; background: transparent; border-radius: 5px;  color: #000000; font-size: 13px; padding: 3px 16px;  border: 1px solid #B4B4B4;}
        }
        &.pac-target-input{ height: 80px;  word-break: break-all; overflow-wrap: break-word;  resize: none;}
      }
      .box-images{ margin: 0; margin-top: 10px; position: relative;
        .item-img{width: 133px; height: 150px;  margin-right: 8px; margin-bottom: 8px; display: inline-flex; position: relative;
          img{max-width: 100%; height: auto;margin: 0 auto; object-fit: contain; padding: 5px;}
          .button-clear{border-radius: 5px; width: 24px; height: 24px; background: #F5564E; float: right; cursor: pointer; position: absolute; right: 0px;
            img{vertical-align: top;}
          }
        }
      }
      .p-invalid{display: block;}
    }
  }
  .fixed-bottom-toolbar{background: transparent; border: 0 none; margin-top: 22px; border-top: 1px solid #B4B4B4; padding: 0; padding-top: 30px;
    .p-button{width: auto; margin-right: 8px;
      &:last-child{margin-right: 0;}
    }
  }
}
</style>